// src/lib/managers/conversation/constants.ts

/**
 * Seuil de masse (règle G2, plan §3.2) : au-delà, aucune action groupée — la liste est affichée en
 * consultation avec une demande de préciser. Valeur provisoire du plan (§9), la même que la garde
 * de l'Api-Ai (IA-1.6). Elle part figée sur mobile avec la version qui l'embarque.
 */
export const MASS_ACTION_MAX = 50;

/**
 * Mails envoyés au plus à une analyse (todo, synthèse, résumé) : les premiers de la liste affichée.
 * La même borne que l'Api-Ai (`ANALYSE_MAX`), qui le dit dans son message quand la liste est plus
 * longue.
 */
export const MAILS_ANALYSIS_MAX = 10;
